import { Clock, BookOpen } from "lucide-react";

export function BlogByline({
  author = "TruWe Clinical Library",
  date,
  readingTime,
  sources = "peer-reviewed medical journals. The Lancet, BMJ, JAMA, NEJM, Nutrients, Cochrane Database of Systematic Reviews and PubMed-indexed research; original authors and journals credited inline.",
}: {
  author?: string;
  date: string; // ISO yyyy-mm-dd
  readingTime: string; // e.g. "8 min read"
  sources?: string;
}) {
  const formatted = new Date(date).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  return (
    <div className="mt-6 space-y-1.5 text-xs text-muted-foreground">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="font-medium text-brand-deep">By {author}</span>
        <span aria-hidden>·</span>
        <time dateTime={date}>Published {formatted}</time>
        <span aria-hidden>·</span>
        <span className="inline-flex items-center gap-1">
          <Clock className="h-3 w-3" />
          {readingTime}
        </span>
      </div>
      <div className="flex flex-wrap items-start gap-x-2 gap-y-1">
        <span className="inline-flex items-start gap-1">
          <BookOpen className="mt-0.5 h-3 w-3 shrink-0 text-brand" />
          <span>Citations from {sources}</span>
        </span>
      </div>
    </div>
  );
}
